import { gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';

const {
  SET_LISTEN_KEY,
  SET_MARGIN_LISTEN_KEY,
  WEB_SOCKET_STREAMER,
} = actionTypes;

const setListenKey = createBaseActions(SET_LISTEN_KEY, 'data');
const setMarginListenKey = createBaseActions(SET_MARGIN_LISTEN_KEY, 'data');
const setPingStreamer = createBaseActions(WEB_SOCKET_STREAMER, 'data');

export const fetchListenKey = () => async dispatch => {
  try {
    const listenData = await gwPost(API_PATH.START_STREAM_API_PATH, setPostBody());
    const listenKey = handleGwData(listenData);
    dispatch(setListenKey(listenKey));
  } catch (e) {
    dispatch(setListenKey(''));
  }
};

export const fetchMarginListenKey = () => async dispatch => {
  try {
    const listenData = await gwPost(API_PATH.START_STREAM_API_PATH, setPostBody({ 'accountType': 'MARGIN' }));
    const listenKey = handleGwData(listenData) || '';
    dispatch(setMarginListenKey(listenKey));
  } catch (e) {
    dispatch(setMarginListenKey(''));
  }
};

export const pingStreamer = listenKey => async dispatch => {
  await gwPost(API_PATH.USER_STREAM_PING_API, setPostBody({ listenKey }));
  dispatch(setPingStreamer());
};

export default {};
